// CORE-1735 slice 17 (D-120, QA V06) — Live icon «mic» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Path, Rect } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Mic: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Rect x={9} y={2} width={6} height={12} rx={3} fill={color} />
    <Path d="M5 10v2a7 7 0 0 0 14 0v-2 M12 19v3 M8 22h8" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" />
    </G>
  </Svg>
);
